import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { Icon } from "../../../icons";
import goToHelpLink from "../../../../utils/goToHelpLink";
import { OssPanel } from "./OssPanel";

const OSS_HELP_URL = "https://help.ese-tech.com/ko/oss";

const OSS_HELP_TITLE_ANCHORS = {
  "주문일정관리 현황": "page-4-0",
  "주문 목록": "page-5-0",
  "확인 필요 주문": "page-5-0",
  "조치 필요 주문": "page-8-0",
  "변경 검토": "page-9-0",
  "문서 관리": "page-10-0",
  "기준정보": "page-11-0",
};

const getOssHelpUrl = (title) => {
  const anchor = OSS_HELP_TITLE_ANCHORS[title];
  return anchor ? `${OSS_HELP_URL}#${anchor}` : OSS_HELP_URL;
};

const OssManualHelpButton = ({ title }) => (
  <Tooltip title="매뉴얼 보기">
    <Box
      component="span"
      role="button"
      aria-label={`${title} 매뉴얼 보기`}
      tabIndex={0}
      onClick={(event) => {
        event.stopPropagation();
        goToHelpLink(getOssHelpUrl(title));
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          goToHelpLink(getOssHelpUrl(title));
        }
      }}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 28,
        borderRadius: "50%",
        color: "text.secondary",
        cursor: "pointer",
        flexShrink: 0,
        transition: "background-color 120ms ease, color 120ms ease",
        "&:hover": {
          bgcolor: "action.hover",
          color: "primary.main",
        },
        "&:focus-visible": {
          outline: "2px solid #6c5ce7",
          outlineOffset: 2,
        },
      }}
    >
      <HelpOutlineIcon fontSize="small" />
    </Box>
  </Tooltip>
);

export const OssPageHeader = ({ title, icon, iconName, actions }) => (
  <OssPanel
    className="oss-page-header"
    sx={{
      minHeight: 64,
      px: { xs: "16px", sm: "22px" },
      py: "14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1.6,
      flexWrap: { xs: "wrap", sm: "nowrap" },
    }}
  >
    <Stack direction="row" alignItems="center" spacing="10px" sx={{ minWidth: 0 }}>
      {iconName ? (
        <Box
          sx={{
            width: 36,
            height: 36,
            bgcolor: "#f0edff",
            borderRadius: "8px",
            flexShrink: 0,
            display: "grid",
            placeItems: "center",
            color: "#6c5ce7",
            "& svg": { display: "block", width: 22, height: 22, margin: 0 },
          }}
        >
          <Icon name={iconName} width={22} height={22} />
        </Box>
      ) : (
        icon
      )}
      <Typography
        component="h1"
        sx={{
          fontSize: "20px !important",
          fontWeight: "700 !important",
          color: "#111827",
          lineHeight: 1.25,
        }}
      >
        {title}
      </Typography>
      <OssManualHelpButton title={title} />
    </Stack>
    <Stack direction="row" spacing="8px" alignItems="center" sx={{ ml: "auto" }}>
      {actions && (
        <>
        {actions}
        </>
      )}
    </Stack>
  </OssPanel>
);
